// App.js
import React, { useState } from "react";
import PhoneNumberInput from "../../components/forget/PhoneNumberInput";
import OtpVerification from "../../components/forget/OtpVerification";
import PasswordReset from "../../components/forget/PasswordReset";


function Forget() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      {!phoneNumber ? (
        <PhoneNumberInput setPhoneNumber={setPhoneNumber} setEmail = {setEmail} />
      ) : !otpVerified ? (
        <OtpVerification phoneNumber={phoneNumber} setOtpVerified={setOtpVerified}  email = {email}/>
      ) : (
        <PasswordReset phoneNumber={phoneNumber} />
      )}
    </div>
  );
}

export default Forget;
